import Page from '../../classes/Page'
import Hero from '../../modules/Hero'
import { app } from '../../utils/store'
import each from 'lodash/each'

export default class ArchiveInspiration extends Page{
    constructor(){
        super({
            id : 'archive_inspiration',
            element: '[data-app-page]',
             elements: { 
                hero : document.querySelectorAll('[data-carousel="hero"]'),
            },
            scroller: document.querySelector('[data-app-viewport]')
        })
    }

    create() {
        super.create()

        console.log(app)

        if (this.elements.hero) { this.createHero() }
    }

     createHero() {
        each(this.elements.hero, (entry) => { return new Hero({ element: entry }) })
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}